<template>
  <div id="app" class="layout-root">
    <el-container class="layout">
      <el-header height="60px" class="header">
        <div class="brand">
          <span class="brand-icon">🧩</span>
          <div class="brand-text">
            <span class="brand-name">来拼图鸭</span>
            <span class="brand-sub">后台管理系统</span>
          </div>
        </div>
        <el-menu
          :default-active="activeMenu"
          mode="horizontal"
          background-color="transparent"
          text-color="rgba(255,255,255,0.85)"
          active-text-color="#fff"
          router
          class="header-menu"
        >
          <el-menu-item index="/daily-puzzles">
            <i class="el-icon-date" />每日一关
          </el-menu-item>
          <el-menu-item index="/player-levels">
            <i class="el-icon-trophy" />玩家关卡
          </el-menu-item>
        </el-menu>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    activeMenu() {
      const p = this.$route.path || ''
      if (p.startsWith('/daily-puzzles')) return '/daily-puzzles'
      if (p.startsWith('/player-levels')) return '/player-levels'
      return '/daily-puzzles'
    }
  }
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}
.layout-root {
  min-height: 100%;
  background: #f0f4f8;
}
.layout {
  min-height: 100vh;
}

/* ── 顶部导航 ── */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 2px 12px rgba(102, 126, 234, 0.4);
  position: sticky;
  top: 0;
  z-index: 100;
}

/* 品牌区 */
.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  text-decoration: none;
}
.brand-icon {
  font-size: 28px;
  line-height: 1;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
}
.brand-text {
  display: flex;
  flex-direction: column;
}
.brand-name {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  line-height: 1.2;
}
.brand-sub {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 1px;
  line-height: 1.2;
}

/* 导航菜单 */
.header-menu {
  border-bottom: none !important;
  flex: 1;
  justify-content: flex-end;
}
.header-menu.el-menu--horizontal {
  background: transparent !important;
}
.header-menu.el-menu--horizontal > .el-menu-item {
  border-bottom: none !important;
  border-radius: 8px;
  margin: 0 4px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
}
.header-menu.el-menu--horizontal > .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.15) !important;
}
.header-menu.el-menu--horizontal > .el-menu-item.is-active {
  background: rgba(255, 255, 255, 0.22) !important;
  font-weight: 600;
}
.header-menu.el-menu--horizontal > .el-menu-item i {
  margin-right: 5px;
  font-size: 14px;
}

/* ── 主内容区 ── */
.main {
  padding: 24px;
  max-width: 1360px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}
</style>
